import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface ObtenerRespuestasPreguntaAsambleaRequest {
  pregunta_codigo: string;
  codigo?: string;
  estatus_codigo: string;
}

export interface RespuestaPreguntaAsambleaRecord {
  rpa_codigo: number | string;
  rpa_pregunta: number | string;
  rpa_pregunta_texto: string;
  rpa_texto: string;
  rpa_orden: string;
  rpa_estatus: string;
  rpa_estatus_nombre: string;
  erp_total: number;
  rpa_ganadora?: string;
}

export interface InsertarRespuestaPreguntaAsambleaRequest {
  usuario_administrador: string;
  pregunta_codigo: string;
  texto: string;
  orden: string;
}

export interface ModificarRespuestaPreguntaAsambleaRequest {
  usuario_administrador: string;
  codigo: string;
  pregunta_codigo: string;
  texto: string;
  orden: string;
}

export interface ModificarEstatusRespuestaPreguntaAsambleaRequest {
  usuario_administrador: string;
  codigo: string;
  pregunta_codigo: string;
  estatus_codigo: string;
}

export const obtenerRespuestasPreguntaAsamblea = async (payload: ObtenerRespuestasPreguntaAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<RespuestaPreguntaAsambleaRecord[]>>(
    "respuesta_pregunta_asamblea/ObtenerTodos",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const insertarRespuestaPreguntaAsamblea = async (payload: InsertarRespuestaPreguntaAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "respuesta_pregunta_asamblea/Insertar",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const modificarRespuestaPreguntaAsamblea = async (payload: ModificarRespuestaPreguntaAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "respuesta_pregunta_asamblea/Modificar",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const modificarEstatusRespuestaPreguntaAsamblea = async (payload: ModificarEstatusRespuestaPreguntaAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "respuesta_pregunta_asamblea/Modificar_Estatus",
    HttpMethod.POST,
    payload
  );

  return envelope;
};
